import React, { useState } from 'react';
import useSWR from 'swr';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { Alert, Box, MenuItem, Snackbar, Tab, Tabs, TextField, Typography } from '@mui/material';
import { ambil, base, denganCabang, pesanGalat } from './bersama';
import TabAturan from './TabAturan';
import TabShiftJadwal from './TabShiftJadwal';
import TabHariLibur from './TabHariLibur';
import TabPengajuan from './TabPengajuan';
import TabKehadiran from './TabKehadiran';

// Pengaturan Absensi per cabang (admin cabang: cabangnya; superadmin: pilih cabang).
// Server: controller/aturanAbsensiController.js, status dihitung di utils/statusKehadiran.js.
const PengaturanAbsensi = () => {
  const { user } = useSelector((state) => state.auth);
  const superadmin = user?.role === 'superadmin';
  // Tautan dari halaman lain: ?tab=shift|libur|pengajuan|kehadiran (&cabang=<uuid> untuk superadmin)
  const [params] = useSearchParams();
  const [tab, setTab] = useState(() => ({ shift: 1, libur: 2, pengajuan: 3, kehadiran: 4 })[params.get('tab')] ?? 0);
  const [cabang, setCabang] = useState(() => params.get('cabang') || '');
  const [pesan, setPesan] = useState('');
  const { data: cabangData } = useSWR(superadmin ? `${base()}/cabangbyrole?bentuk=objek` : null, ambil);
  const daftarCabang = Array.isArray(cabangData?.data) ? cabangData.data : [];
  const perluCabang = superadmin && !cabang;
  const { data, error, mutate } = useSWR(perluCabang ? null : denganCabang('/absensi/pengaturan', cabang), ambil);

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6">Pengaturan Absensi</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Aturan kehadiran, shift & jadwal karyawan, hari libur, izin/sakit/cuti, dan hitung gaji dari absensi untuk cabang ini.
      </Typography>
      {superadmin && (
        <TextField size="small" select label="Cabang" value={cabang} onChange={(e) => setCabang(e.target.value)} sx={{ minWidth: 240, mb: 2 }}>
          {daftarCabang.map((c) => <MenuItem key={c.uuid} value={c.uuid}>{c.namacabang}</MenuItem>)}
        </TextField>
      )}
      <Tabs value={tab} onChange={(_, v) => setTab(v)} variant="scrollable" sx={{ mb: 2 }}>
        <Tab label="Aturan" />
        <Tab label="Shift & Jadwal" />
        <Tab label="Hari Libur" />
        <Tab label="Pengajuan" />
        <Tab label="Kehadiran & Gaji" />
      </Tabs>
      {perluCabang && tab !== 2 && <Alert severity="info">Pilih cabang dulu.</Alert>}
      {error && <Alert severity="error">{pesanGalat(error)}</Alert>}
      {!perluCabang && tab === 0 && <TabAturan data={data?.data} cabang={cabang} onTersimpan={(m) => { setPesan(m); mutate(); }} />}
      {!perluCabang && tab === 1 && <TabShiftJadwal shift={data?.shift} cabang={cabang} muatUlangPengaturan={mutate} onPesan={setPesan} />}
      {tab === 2 && <TabHariLibur cabang={cabang} superadmin={superadmin} onPesan={setPesan} />}
      {!perluCabang && tab === 3 && <TabPengajuan cabang={cabang} onPesan={setPesan} />}
      {!perluCabang && tab === 4 && <TabKehadiran cabang={cabang} />}
      <Snackbar open={!!pesan} autoHideDuration={3000} onClose={() => setPesan('')} message={pesan} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} />
    </Box>
  );
};

export default PengaturanAbsensi;
